import { SignUpStage } from './interfaces';
import { createProxy } from '../../toolkit/proxy';
export const initialState = {
  loading: false,
  allowSignUps: false,
  allowNotVerifiedUsersLogin: false,
  firstLoad: true,
  stage: SignUpStage.SignUp
};
export default (overrideState => createProxy(initialState, overrideState));